import * as Mui from "@mui/material";

const CategoriesSelect = ({
  data,
  urunKategori,
  handleOnChange,
  defaultTitle,
}) => {
  return (
    <>
      {data.isLoading && <Mui.Skeleton height={40} />}
      {!data.isLoading && (
        <>
          {!data.isError && (
            <div className="relative">
              <select
                name="kategori"
                onChange={handleOnChange}
                className="select-menu"
                value={urunKategori}
              >
                <option value={0}>{defaultTitle}</option>
                {data?.data?.length > 0 &&
                  data.data.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.title}
                    </option>
                  ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  className="w-4 h-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </div>
            </div>
          )}
          {data.isError && (
            <div className="relative">
              <select
                name="kategori"
                onChange={handleOnChange}
                className="select-menu"
              >
                <option value={0}>Kategori Bulunamadı</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  className="w-4 h-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default CategoriesSelect;
